import { atom } from 'jotai';
import { protectedApiCall } from '../../api/network';

interface statsStateInterface {
    groupID: string;
    data: any;
    loading: boolean;
}

export const INITIAL_STATS_ATOM_VALUE: statsStateInterface = {
    groupID: "",
    data: undefined,
    loading: true
};

export const statsAtom = atom(INITIAL_STATS_ATOM_VALUE);

export function loadStats(set, session, groupID) {
    set((stats) => {
        return {
            ...stats,
            loading: true
        }
    })

    protectedApiCall(session, 'refactor/legacy/stats', {}, {
        params: {
            groupID: groupID
        }
    }, 'get').then((r) => {
        set((s) => {
            return {
                ...s,
                groupID: groupID,
                data: r,
                loading: false
            }
        })
    });
}
